import React from 'react';
import { usePermissions, useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';

export function HomeModule() {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return (
    <>
      <PageTitle
        eyebrow={t('Dashboard')}
        title={t(
          `Welcome back, ${permissions.location?.customer_dba_name || permissions.location?.customer_name || ''}`,
        )}
        subtitle={t('Your fleet overview.')}
      />
    </>
  );
}
